import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useTranslation } from 'react-i18next';

export const useVehicleTypes = () => {
  const { t } = useTranslation();
  
  const { data: vehicleTypes = [], isLoading } = useQuery({
    queryKey: ['vehicle-types'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('vehicle_types')
        .select('*');

      if (error) throw error;
      
      // Sort with "Autre" (other) at the end
      return data.sort((a, b) => {
        if (a.trailer_type === 'other') return 1;
        if (b.trailer_type === 'other') return -1;
        return a.name.localeCompare(b.name);
      });
    },
  });

  // Function to get translated vehicle type name
  const getVehicleTypeName = (trailerType: string): string => {
    return t(`vehicleTypes.${trailerType}`, { defaultValue: trailerType });
  };

  return {
    vehicleTypes,
    isLoading,
    getVehicleTypeName,
  };
};
